import { create } from 'zustand';

/** Push notifications on this phone, as the Android app's settings and prompt show them. Unused on the website. */
export interface PushState {
  /** The server has FCM credentials. */
  serverEnabled: boolean;
  /** The phone can get an FCM token (Firebase set up in the build, Google Play services present). */
  deviceSupported: boolean;
  permission: 'granted' | 'denied' | 'prompt' | 'unknown';
  /** This phone's token is registered for the signed-in session. */
  registered: boolean;
  /** The person turned push off for this phone in settings. */
  disabledHere: boolean;
  previews: boolean;
  /** Show the one-time explanation before asking Android for permission. */
  promptVisible: boolean;
}

export const usePushState = create<PushState>(() => ({
  serverEnabled: false,
  deviceSupported: true,
  permission: 'unknown',
  registered: false,
  disabledHere: false,
  previews: true,
  promptVisible: false,
}));
